import { render, staticRenderFns } from "./DeRichText.vue?vue&type=template&id=6e810320&scoped=true&"
import script from "./DeRichText.vue?vue&type=script&lang=js&"
export * from "./DeRichText.vue?vue&type=script&lang=js&"
import style0 from "./DeRichText.vue?vue&type=style&index=0&id=6e810320&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e810320",
  null
  
)

export default component.exports